import { Pagination, useLocale } from 'shared-ui';

import { ExpandableList } from 'ui/expandableList/ExpandableList';
import { findServerToExpand } from 'helpers/findServerToExpand';
import { AppMessages } from 'i18n/messages';

import { SchedulesExceptionsTableContainer } from './schedulesExceptionsTable/SchedulesExceptionsTableContainer';
import { SchedulesExceptionsProps } from './SchedulesExceptions.types';

export const SchedulesExceptions = ({
  servers,
  isLoading,
  page,
  setPage,
  rowsPerPage,
  setRowsPerPage,
  schedulesExceptionsCount,
  setSchedulesExceptionsCount,
}: SchedulesExceptionsProps) => {
  const { formatMessage } = useLocale();

  return (
    <>
      <Pagination
        page={page}
        setPage={setPage}
        count={schedulesExceptionsCount}
        rowsPerPage={rowsPerPage}
        setRowsPerPage={setRowsPerPage}
      />

      <ExpandableList
        data={servers || []}
        isLoading={isLoading}
        title={(server) => server.nazwa}
        initiallyExpandedItem={findServerToExpand(servers || [])}
        toggleItemExpansion={(expandedServer) => {
          if (!expandedServer) setSchedulesExceptionsCount(0);
        }}
        onClickExpandButton={() => {
          setPage(0);
        }}
        nothingToShowText={formatMessage({ id: AppMessages['schedules.noResults.nothingToShowText'] })}
        renderExpandableItemBody={(server, expandedServer) => (
          <SchedulesExceptionsTableContainer
            key={server.id}
            expandedServer={expandedServer}
            setSchedulesCount={setSchedulesExceptionsCount}
          />
        )}
      />
    </>
  );
};
